module.exports = __webpack_public_path__ + "static/future-ai-img-1-c9bafa248543a3e3163ff1c56f2e146f.png";